import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[searchInput]',
    standalone: false,
})
export class SearchInputDirective {
    @HostBinding('class') elementClass = 'search-input';
}
